// extracted by mini-css-extract-plugin
export default {"mainCard":"Category_mainCard__oo3Ii","mainImg":"Category_mainImg__3eofM","imgTitle":"Category_imgTitle__WOysL","checkout_form":"Category_checkout_form__hcUYa"};